<app-report-runner
  reportType="client-demographics"
  title="Client Demographics Report"
  description="Race, ethnicity, gender, and ZIP Code breakdowns for distinct clients served in the selected period."
/>
